import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Ecological sensitivity or fragility refers to the permanent and
              irreparable loss of extant life forms or significant damage to the
              natural processes of evolution and speciation with the alterations
              in the ecological integrity of a region. The comprehensive
              knowledge of the ecological fragility of a region is
              quintessential for evolving strategies for conserving the area,
              which entails identifying factors responsible for ecological
              sensitiveness, including landscape dynamics, and visualizing
              future transitions to mitigate the problems of haphazard and
              uncontrolled development approaches. Analyses of ecologically
              sensitive regions in the Western Ghats, one among 36 global
              biodiversity hotspots using temporal remote sensing data,
              highlight serious concerns about the status of forests and
              conservation measures. Ecological sensitive region (ESR)
              delineation considers abiotic, biotic, and socio/anthropological
              factors, reflecting the current status of the fragile landscape
              and their significance in maintaining ecosystem equilibrium. ESR
              analyses depict 63,148 km<sup>2</sup> area under significantly
              higher ecological fragility, 27,646 km<sup>2</sup> under high
              ecological fragility, 48,490 km<sup>2</sup> as moderate, and
              20,716 km<sup>2</sup> as low ecological fragility. Integrating
              ESRs in the sustainable development policy framework would aid in
              regulating unplanned developmental activities, which aid in
              ensuring ecological security with the continuance of the essential
              ecosystem services to sustain the livelihood of people.
            </p>
            <p>
              Keywords: Biodiversity; Conservation; Cluster-based development;
              Ecological Fragility; Endemic Species, Sustainable Development
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
